/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useIntl } from 'react-intl'
import FormField, {
  FormTextFieldProps
} from '../../../../client/js/components/form/fields/FormField'

function EmailField (props: FormTextFieldProps) {
  const { name = 'email', ...others } = props
  const intl = useIntl()
  return (
    <FormField
      autoComplete="email"
      label={intl.formatMessage({
        id: 'email',
        defaultMessage: 'Adresse e-mail'
      })}
      name={name}
      type="email"
      leftSection={(
        <FontAwesomeIcon
          fixedWidth
          icon={faEnvelope}
        />
      )}
      {...others}
    />
  )
}

export default EmailField
